import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: function () {
      return import('../views/Home.vue').catch(err => err)
    },
    meta: {
      title: "北京九州泰岳科技开发有限公司官网"
    }
  },
  {
    path: '/ProductIntroduction',
    name: 'ProductIntroduction',
    component: function () {
      return import('../views/ProductIntroduction.vue').catch(err => err)
    },
  },
  {
    path: '/ServiceSupport',
    name: 'ServiceSupport',
    component: function () {
      return import('../views/ServiceSupport.vue').catch(err => err)
    },
    meta: {
      title: "服务支持"
    }
  },
  {
    path: '/Register',
    name: 'Register',
    component: function () {
      return import('../views/Register.vue').catch(err => err)
    },
    meta: {
      title: "用户注册"
    }
  },
  {
    path: '/Product-technology',
    name: 'Product-technology',
    component: function () {
      return import('../views/Product-technology.vue').catch(err => err)
    },
    meta: {
      title: "产品技术"
    }
  },
  {
    path: '/About-us',
    name: 'About-us',
    component: function () {
      return import('../views/About-us.vue').catch(err => err)
    },
    meta: {
      title: "关于我们"
    }
  },
  {
    path: '/Solution',
    name: 'Solution',
    component: function () {
      return import('../views/Solution.vue').catch(err => err)
    },
    meta: {
      title: "解决方案"
    }
  },
  {
    path: '/Customer-training',
    name: 'Customer-training',
    component: function () {
      return import('../views/Customer-training.vue').catch(err => err)
    },
    meta: {
      title: "客户培训"
    }
  },
  {
    path: '/cooperative-partner',
    name: 'cooperative-partner',
    component: function () {
      return import('../views/cooperative-partner.vue').catch(err => err)
    },
    meta: {
      title: "合作伙伴"
    }
  },
  {
    path: '/Reset',
    name: 'Reset',
    component: function () {
      return import('../views/Reset.vue').catch(err => err)
    },
    meta: {
      title: "忘记密码"
    }
  },
  {
    path: '/BecomeApartner',
    name: 'BecomeApartner',
    component: function () {
      return import('../views/BecomeApartner.vue').catch(err => err)
    },
    meta: {
      title: "成为合作伙伴"
    }
  },
  {
    path: '/productDetails',
    name: 'productDetails',
    component: function () {
      return import('../views/productDetails.vue').catch(err => err)
    },
    meta: {
      title: "产品介绍"
    }
  },
  {
    path: '/product-Item',
    name: 'product-Item',
    component: function () {
      return import('../views/product-Item.vue').catch(err => err)
    },
    meta: {
      title: "产品详情"
    }
  },
  {
    path: '/Query-partner',
    name: 'Query-partner',
    component: function () {
      return import('../views/Query-partner.vue').catch(err => err)
    },
    meta: {
      title: "查询合作伙伴"
    }
  },
  {
    path: '/Feedback',
    name: 'Feedback',
    component: function () {
      return import('../views/Feedback.vue').catch(err => err)
    },
    meta: {
      title: "意见反馈"
    }
  },
  {
    path: '/News-detail',
    name: 'News-detail',
    component: function () {
      return import('../views/News-detail.vue').catch(err => err)
    },
    meta: {
      title: "公告通知详情"
    }
  },
  {
    path: '/Bottom-navDetail',
    name: 'Bottom-navDetail',
    component: function () {
      return import('../views/Bottom-navDetail.vue').catch(err => err)
    },
    meta: {
      title: "底部导航详情"
    }
  },
  {
    path: '/video-list',
    name: 'video-list',
    component: function () {
      return import('../views/video-list.vue').catch(err => err)
    },
    meta: {
      title: "产品发布"
    }
  }
]

const router = new VueRouter({
  // mode: 'history', 
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
